import { useLanguageStore } from '@/context/LanguageStore';
import * as React from 'react';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import consts from '@/config/consts';

export function useTranslation() {
  const lang = useLanguageStore(state => state.lang);
  const url = `/configs/strings_${lang}.json`;

  const { data } = useQuery({
    queryKey: ['strings', lang],

    queryFn: () =>
      axios({
        method: 'get',
        url: url,
        baseURL: consts.storageUrl,
      }).then(response => {
        const returnData: Record<string, string> = {};
        Object.keys(response.data).map(key => {
          returnData[key.toLocaleLowerCase()] = response.data[key];
        });

        return returnData;
      }),

    enabled: !!lang,
  });

  const t = React.useCallback(
    (key: string, fallback?: string): string => {
      return data?.[key.toLocaleLowerCase()] ?? fallback ?? key;
    },
    [data],
  );

  return { t };
}
